import React, { useState } from "react";
import { createUseStyles } from "react-jss";
import PropTypes from "prop-types";
import { useController } from "react-hook-form";
import i18n from "../../../utils/locale/i18n";

import Icon from "../icon";
import inputPasswordToggleSkin from "../../../skins/input-password-toggle.skin";

const useStyles = createUseStyles(inputPasswordToggleSkin);

function InputPasswordToggle({
  control,
  name: originalName,
  value: originalValue,
  className,
  required,
  placeholder,
  id,
  fieldOptions: { maxLength } = {},
  domStep,
}) {
  const [showPassword, setShowPassword] = useState(false);
  const classes = useStyles();

  const {
    field: { onChange, onBlur, name, value },
  } = useController({
    name: originalName,
    control,
    defaultValue: originalValue,
    shouldUnregister: true,
  });

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div className={classes.inputWrapper}>
      <input
        className={`${className} ${classes.styledInput}`}
        id={id}
        name={name}
        onBlur={onBlur}
        onChange={onChange}
        placeholder={placeholder}
        required={required}
        type={showPassword ? "text" : "password"}
        value={value}
        step={domStep}
        maxLength={maxLength}
      />
      <button
        type="button"
        className={classes.showPasswordButton}
        onClick={togglePasswordVisibility}
        title={showPassword ? i18n.t("hide") : i18n.t("show")}
      >
        {showPassword ? <Icon icon="eye-slash" /> : <Icon icon="eye" />}
      </button>
    </div>
  );
}

InputPasswordToggle.propTypes = {
  className: PropTypes.string,
  control: PropTypes.object,
  id: PropTypes.string,
  name: PropTypes.string,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  value: PropTypes.string,
  fieldOptions: PropTypes.shape({
    maxLength: PropTypes.number,
  }),
  domStep: PropTypes.string,
};

export default InputPasswordToggle;
